import { Record } from 'immutable';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"flux-actions"' has no exported member 'co... Remove this comment to see the full error message
import { handleActions, combineActions } from 'flux-actions';
import { REGISTER_SMS, VERIFY_SMS, VERIFICATION_SUCCESSFUL } from '../../constants/security/SecurityPhoneNumberSetupSteps';
import { indexOfStep } from '../../constants/security/SecurityPhoneNumberSetupStepOrder';
import { SecurityPhoneNumberActionTypes } from '../../actions/security/SecurityPhoneNumberActions';
const UNINITIALIZED_INDEX = -1;
const SecurityPhoneNumberSetupState = Record({
  setupStepIndex: UNINITIALIZED_INDEX,
  stagedSMSNumber: '',
  isErrorSendingSMS: undefined,
  verificationCodeAttempt: '',
  verificationCodeFailure: false,
  redirectUrl: undefined
}, 'SecurityPhoneNumberSetupState');
const initialState = new SecurityPhoneNumberSetupState();
export default handleActions({
  [SecurityPhoneNumberActionTypes.SETUP_FROM_LOGIN](state, action) {
    return state.merge({
      setupStepIndex: indexOfStep(REGISTER_SMS),
      redirectUrl: action.payload.redirectUrl
    });
  },
  [SecurityPhoneNumberActionTypes.CLICKED_SETUP](state) {
    return state.merge({
      setupStepIndex: indexOfStep(REGISTER_SMS)
    });
  },
  [SecurityPhoneNumberActionTypes.CLICKED_VERIFY](state) {
    return state.merge({
      setupStepIndex: indexOfStep(VERIFY_SMS)
    });
  },
  [combineActions(SecurityPhoneNumberActionTypes.COMPLETED_SETUP, SecurityPhoneNumberActionTypes.CANCELLED_SETUP)](state) {
    if (!state.redirectUrl) {
      return state.merge(initialState);
    }
    return state;
  },
  [SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_SUCCESSFUL](state, action) {
    return state.merge({
      stagedSMSNumber: action.payload.securityPhoneNumber.info
    });
  },
  [SecurityPhoneNumberActionTypes.CHANGE_SMS_NUMBER](state, action) {
    return state.merge({
      stagedSMSNumber: action.payload.phoneNumber
    });
  },
  [SecurityPhoneNumberActionTypes.CONFIGURE_SMS](state) {
    return state.merge({
      verificationCodeAttempt: '',
      verificationCodeFailure: false
    });
  },
  [SecurityPhoneNumberActionTypes.CONFIGURE_SMS_SUCCESS](state) {
    return state.mergeDeep({
      setupStepIndex: indexOfStep(VERIFY_SMS),
      isErrorSendingSMS: false
    });
  },
  [SecurityPhoneNumberActionTypes.CONFIGURE_SMS_FAILURE](state) {
    return state.set('isErrorSendingSMS', true);
  },
  [SecurityPhoneNumberActionTypes.CODE_ATTEMPT_SUCCESS](state) {
    return state.merge({
      setupStepIndex: indexOfStep(VERIFICATION_SUCCESSFUL)
    });
  },
  [SecurityPhoneNumberActionTypes.CODE_ATTEMPT_FAILURE](state) {
    return state.merge({
      verificationCodeFailure: true
    });
  },
  [SecurityPhoneNumberActionTypes.CHANGED_CODE_ATTEMPT](state, action) {
    return state.merge({
      verificationCodeAttempt: action.payload.codeAttempt,
      verificationCodeFailure: false
    });
  }
}, initialState);